import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GenericService } from 'src/app/generic.service';
import { AddressTemplate, Client, ScreenSize } from 'src/app/models';

@Component({
  selector: 'app-out-address',
  templateUrl: './out-address.component.html',
  styles: [
  ]
})
export class OutAddressComponent implements OnInit {
  @Input() uid: string;
  @Output() fdataChanged: EventEmitter<number> = new EventEmitter();
  title = 'Current Address';
  size = new ScreenSize();
  iForm: FormGroup;
  filteredAddresses: any[];
  iloading = false;
  isFormChanged = false;

  constructor(private formBuilder: FormBuilder, public service: GenericService) {
    this.size = this.service.size;
  }

  get f(): any { return this.iForm.controls; }

  ngOnInit(): void {
    
    this.iForm = this.formBuilder.group({
      country: ['AUSTRALIA', Validators.required],
      addressLine1: [null, Validators.required],
      addressLine2: [null],
      suburb: [null, Validators.required],
      state: [null, Validators.required],
      postCode: [null, Validators.required],
      userInput: null
    });

   
    this.iForm.get('userInput').valueChanges.subscribe(val => {
      if (val !== '' && val !== null && val.length > 6) {
        this.service.searchAddress(val).then(response => {
          this.filteredAddresses = response.result as any[];
        });
      }
    });

    this.onChanges();
  }

  onAddressSelect(address: AddressTemplate): void {
    this.iForm.get('country').setValue('Australia');
    if (address.flatNumber !== null) {
      this.iForm.get('addressLine1').setValue(address.flatNumber + '/' + address.numberFirst);
      this.iForm.get('addressLine2').setValue(address.streetName + ' ' + address.streetType);
    }

    if (address.levelNumber !== null) {
      this.iForm.get('addressLine1').setValue(address.levelNumber + '/' + address.numberFirst);
      this.iForm.get('addressLine2').setValue(address.streetName + ' ' + address.streetType);
    }

    if (address.flatNumber === null && address.levelNumber == null) {
      this.iForm.get('addressLine1').setValue(address.numberFirst + ' ' + address.streetName + ' ' + address.streetType);
    }

    this.iForm.get('suburb').setValue(address.suburb);
    this.iForm.get('state').setValue(address.state);
    this.iForm.get('postCode').setValue(address.postCode);

    this.iForm.get('userInput').setValue(null);
  }

  onChanges(): void {
    this.iForm.valueChanges.subscribe(val => {
      const country = this.service.isValChanged(this.iForm.get('country').value, 'AUSTRALIA');
      const addressLine1 = this.service.isValChanged(this.iForm.get('addressLine1').value, null);
      const addressLine2 = this.service.isValChanged(this.iForm.get('addressLine2').value, null);
      const suburb = this.service.isValChanged(this.iForm.get('suburb').value, null);
      const state = this.service.isValChanged(this.iForm.get('state').value, null);
      const postCode = this.service.isValChanged(this.iForm.get('postCode').value, null);

      if (country || addressLine1 || addressLine2 || suburb || state || postCode) {
        this.isFormChanged = true;
      } else {
        this.isFormChanged = false;
      }
    });
  }

 

  onSubmit(): void {
    this.iloading = true;

    const country = this.iForm.get('country').value;
    const addressLine1 = this.iForm.get('addressLine1').value;
    const addressLine2 = this.iForm.get('addressLine2').value;
    const suburb = this.iForm.get('suburb').value;
    const state = this.iForm.get('state').value;
    const postCode = this.iForm.get('postCode').value;
    const uid = this.uid;

    var model = {Uid: uid, Country: country, AddressLine1: addressLine1, AddressLine2: addressLine2, Suburb: suburb, State: state, PostCode: postCode};

    this.service.postDataByModel('authority/UpdateAddress', model).then(response => {
      if (response.success) {
        this.service.success('Saved Successfully');
        this.fdataChanged.emit();
        this.isFormChanged = false;
      } else {
        this.service.error(response.error);
      }
      this.iloading = false;
    });
  }

}
